import React from 'react';
import { FormGroup, FormGroupProps } from 'reactstrap';

export interface INSFormGroupProps extends FormGroupProps {
    className?: string;
    children: React.ReactNode | React.ReactNode[];
}

const NSFormGroup = ({ className, children, ...rest }: INSFormGroupProps) => (
    <FormGroup {...rest} className={className || 'mt-3 mb-0'}>
        {children}
    </FormGroup>
);

export default NSFormGroup;
